import React from 'react';
import { IconName } from '@fortawesome/fontawesome-common-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';
import style from './style.module.scss';
import { AutomationStatuses } from '@components-clean/core/grid/grid-status/types';
import Tooltip from '@components-clean/core/tooltip';

const statusMap: Record<AutomationStatuses, { icon: IconName; supplementaryClassName: string }> = {
    Success: { icon: 'check', supplementaryClassName: style.success },
    Failed: { icon: 'times', supplementaryClassName: style.fail },
    'Not Run': { icon: 'minus', supplementaryClassName: style.notRun },
};

interface AutomationStatusIconProps {
    status: AutomationStatuses;
    testId: string;
    toolTipText?: string;
}

const AutomationStatusIcon: React.FC<AutomationStatusIconProps> = ({ status, testId, toolTipText }) => {
    const config = statusMap[status];

    return (
        <Tooltip position="bottom" isInactive={false}>
            <FontAwesomeIcon
                aria-label={toolTipText}
                icon={['far', config.icon]}
                className={cn(style.statusIcon, config.supplementaryClassName)}
                data-testid={testId}
            />
        </Tooltip>
    );
};

export default AutomationStatusIcon;
